import { RigidBody } from "@react-three/rapier/";
import { TextureLoader, RepeatWrapping } from "three";
import { useLoader } from "@react-three/fiber";
import { useRef, useEffect } from "react";
import { Mesh } from "three";

const Ground = () => {
  // Load the grass texture
  const texture = useLoader(TextureLoader, "/images/textures/grass.png");

  // Define the ref type as THREE.Mesh
  const meshRef = useRef<Mesh>(null);

  // Configure texture wrapping and randomized offsets
  useEffect(() => {
    texture.wrapS = RepeatWrapping; // Enable horizontal repetition
    texture.wrapT = RepeatWrapping; // Enable vertical repetition

    // Tiling factor for seamless small tiles
    const tilingFactor = 200; // Adjust for tile size
    texture.repeat.set(tilingFactor, tilingFactor);

    // Randomized offset for the texture
    const randomOffsetX = Math.random(); // Random number between 0 and 1
    const randomOffsetY = Math.random(); // Random number between 0 and 1
    texture.offset.set(randomOffsetX, randomOffsetY); // Apply offset for variation

    texture.needsUpdate = true; // Signal Three.js to update the texture properties
  }, [texture]);

  return (
    <>
      <RigidBody name={"ground"} type="fixed">
        <mesh ref={meshRef} receiveShadow position={[0, -3.5, 0]}>
          <boxGeometry args={[1000, 5, 1000]} />
          <meshStandardMaterial map={texture} />
        </mesh>
      </RigidBody>
    </>
  );
};

export default Ground;
